
export function applySortSettings(enumerable, sortSettings) {
    if(sortSettings.order === "asc")
    { return enumerable.orderBy(x => x[sortSettings.sort]); }
    else
    { return enumerable.orderByDescending(x => x[sortSettings.sort]); }
}

export function applyPageSettings(enumerable, pageSettings) {
    return enumerable
        .skip((pageSettings.pageNo-1) * pageSettings.pageSize)
        .take(pageSettings.pageSize);
}